import { render, staticRenderFns } from "./sdproduct13.vue?vue&type=template&id=4a461450&scoped=true"
import script from "./sdproduct13.vue?vue&type=script&lang=js"
export * from "./sdproduct13.vue?vue&type=script&lang=js"
import style0 from "./sdproduct13.vue?vue&type=style&index=0&id=4a461450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a461450",
  null
  
)

export default component.exports